import { useCallback, useEffect, useRef, useState } from "react";
import _ from "lodash";
import { useDispatch } from "react-redux";

import { changeExpand } from "../../../redux/boardListSlice";
import { searchBoard } from "../../../redux/SearchSlice";
import { isAdmin } from "../../../utils/constants";

export function useBoardSearchState(setSearchBar) {
  const [inputValue, setInputValue] = useState("");
  const dispatch = useDispatch();

  const debouncedSearch = useRef(
    _.debounce((value) => {
      dispatch(searchBoard(value));
    }, 300)
  ).current;

  useEffect(() => {
    return () => {
      debouncedSearch.cancel();
    };
  }, [debouncedSearch]);

  const handleChange = useCallback(
    (event) => {
      if (isAdmin()) {
        dispatch(changeExpand("allPanel"));
      }
      const value = event?.target?.value || "";
      setInputValue(value);
      debouncedSearch(value);
    },
    [debouncedSearch, dispatch]
  );

  const handleClear = useCallback(
    (event) => {
      event.stopPropagation();
      setInputValue("");
      dispatch(searchBoard(""));
      setSearchBar?.({
        showSearchIcon: true,
        showSearchBar: false,
      });
    },
    [dispatch, setSearchBar]
  );

  return {
    handleChange,
    handleClear,
    inputValue,
  };
}
